import type { Patient, Reference } from '@medplum/fhirtypes'
import type { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import { Button, cn, TypographySubtle } from '@seen/ui'
import { IconPlus } from '@tabler/icons-react'
import type { JSX } from 'react'
import { IconTaskState } from '#src/components/icons/IconTaskState.tsx'
import { TaskStateText } from '#src/components/task/TaskStateText.tsx'
import { TaskRowCheckbox } from '#src/components/TaskRowCheckbox.tsx'
import {
  type TaskComposerDefaultValues,
  useTaskComposerStore,
} from '#src/hooks/useTaskComposerStore.ts'

export interface TaskListStateGroupHeaderProps {
  state: StandardTask['state']
  defaultValues?: TaskComposerDefaultValues
  participant?: Reference<Patient>
  hideCheckbox?: boolean
  checked?: boolean
  onCheckedChange?: (value: boolean) => void
}

export function TaskListStateGroupHeader({
  state,
  defaultValues,
  participant,
  hideCheckbox,
  checked,
  onCheckedChange,
}: TaskListStateGroupHeaderProps): JSX.Element {
  const setOpen = useTaskComposerStore((state) => state.setOpen)
  const setDefaultValues = useTaskComposerStore(
    (state) => state.setDefaultValues
  )

  const handleAddTask = (state: StandardTask['state']): void => {
    setOpen(true)
    setDefaultValues({ ...defaultValues, state, participant })
  }

  return (
    <div
      className={cn(
        'group flex items-center justify-between bg-frame px-pagex-default lg:px-pagex-lg',
        !hideCheckbox && 'pr-8 pl-0 lg:pr-8 lg:pl-0'
      )}
    >
      {!hideCheckbox && (
        <TaskRowCheckbox value={checked} onChange={onCheckedChange} />
      )}
      <div className="flex flex-1 items-center gap-2">
        <IconTaskState state={state} />
        <TypographySubtle className="font-medium">
          <TaskStateText state={state} />
        </TypographySubtle>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          'ml-2 rounded-none',
          '-mr-2.5' // Align with the task row
        )}
        onClick={() => handleAddTask(state)}
      >
        <IconPlus className="size-4" />
      </Button>
    </div>
  )
}
